import React, { memo } from 'react'
import { BW_COLOR_SUCCESS } from 'src/libs/qb-brand-web-components'
import { Trans } from 'react-i18next'

import { MESSAGE_TEXT } from '../../../constants/messages'
import Popup from '../../shared/popup/Popup'
import customConfig from 'customConfig'
import Text from '../../text/Text'
import AnimateRewards from '../../shared/animateRewards/AnimateRewards'
import { faCheckCircle } from '@fortawesome/pro-duotone-svg-icons'

const NftCodeSuccess = ({ reward, onAwesomeClick, t }) => {
  const isFutureReward = reward?.campaign?.deltaSeconds
  return (
    <Popup
      title={
        isFutureReward
          ? t('reward.future-reward-nft')
          : t(customConfig.nftReceivedTitle)
      }
      description={
        isFutureReward ? (
          <Trans
            i18nKey='reward.future-reward-success'
            values={{
              value: 1,
              name: reward?.campaign?.token?.name
            }}
          />
        ) : (
          t(MESSAGE_TEXT.NFT_SUCCESS_DESCRIPTION)
        )
      }
      icon={faCheckCircle}
      color={BW_COLOR_SUCCESS}
      onFormSubmit={onAwesomeClick}
      submitLabel={t(
        isFutureReward ? 'common.awesome' : 'brand:nft.get-added-reward'
      )}
    >
      <>
        {isFutureReward && <Text label={t('reward.future-reward-desc-nft')} />}
        <AnimateRewards />
      </>
    </Popup>
  )
}

export default memo(NftCodeSuccess)
